export const detectImageMimeFromBase64 = (
  value?: string | null,
  fallback = 'image/png',
): string => {
  if (!value) return fallback;

  const trimmed = value.trim();
  const dataUrlMatch = trimmed.match(/^data:([^;,]+)[;,]/i);
  if (dataUrlMatch?.[1]) {
    return dataUrlMatch[1].toLowerCase();
  }

  const compact = trimmed.replace(/\s+/g, '');
  if (compact.startsWith('/9j/')) return 'image/jpeg';
  if (compact.startsWith('iVBORw0KGgo')) return 'image/png';
  if (compact.startsWith('UklGR')) return 'image/webp';
  if (compact.startsWith('R0lGOD')) return 'image/gif';

  return fallback;
};

export const detectImageMimeFromBytes = (
  bytes: Uint8Array,
  fallback = 'image/png',
): string => {
  if (bytes.length >= 3 && bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
    return 'image/jpeg';
  }
  if (
    bytes.length >= 8 &&
    bytes[0] === 0x89 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x4e &&
    bytes[3] === 0x47 &&
    bytes[4] === 0x0d &&
    bytes[5] === 0x0a &&
    bytes[6] === 0x1a &&
    bytes[7] === 0x0a
  ) {
    return 'image/png';
  }
  if (
    bytes.length >= 12 &&
    bytes[0] === 0x52 &&
    bytes[1] === 0x49 &&
    bytes[2] === 0x46 &&
    bytes[3] === 0x46 &&
    bytes[8] === 0x57 &&
    bytes[9] === 0x45 &&
    bytes[10] === 0x42 &&
    bytes[11] === 0x50
  ) {
    return 'image/webp';
  }
  if (
    bytes.length >= 6 &&
    bytes[0] === 0x47 &&
    bytes[1] === 0x49 &&
    bytes[2] === 0x46 &&
    bytes[3] === 0x38
  ) {
    return 'image/gif';
  }
  return fallback;
};

export const detectImageMimeFromBlob = async (
  blob: Blob,
  fallback = 'image/png',
): Promise<string> => {
  const prefix = new Uint8Array(await blob.slice(0, 16).arrayBuffer());
  return detectImageMimeFromBytes(prefix, fallback);
};

export const extensionForImageMime = (mime: string): string => {
  const normalized = (mime || '').toLowerCase();
  if (normalized.includes('jpeg') || normalized.includes('jpg')) return 'jpg';
  if (normalized.includes('webp')) return 'webp';
  if (normalized.includes('gif')) return 'gif';
  return 'png';
};

export const imageDataUrlFromBase64 = (
  base64: string,
  fallback = 'image/png',
): string => `data:${detectImageMimeFromBase64(base64, fallback)};base64,${base64}`;
